import { useMemo } from 'react'
// eslint-disable-next-line import/no-cycle
import { replaceParamsInString } from 'helpers/utils'
import { getSystemMessageById } from './utils'

const SystemMessages = ({ id, systemMessages, params }) => {
  const translateLabel = useMemo(() => {
    const string = getSystemMessageById(id, systemMessages)
    return replaceParamsInString(id, string, params)
  }, [systemMessages, params, id])

  return translateLabel
}

export default SystemMessages
